export const DELETE_CATEGORY='DELETE_CATEGORY'
export const DELETE_CATEGORY_SUCCESS= 'DELETE_CATEGORY_SUCCESS'
export const DELETE_CATEGORY_ERROR= 'DELETE_CATEGORY_ERROR'

export const DeleteCategory= (data) => ({
    type: DELETE_CATEGORY,
    payload: data
})